module.exports = __webpack_public_path__ + "static/media/osrit_logo.b849bf34.png";